




























































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import RoleRequest from "@/models/security/roleRequest.model";
import { RowTable } from "@/typings/BRowTable";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";

@Component({
  components: {
    ResearchCenterBasicInformationComponent
  }
})
export default class RoleRequestTable extends GenericBTable<RoleRequest> {
  created() {
    this.tableConfig.controller = "RoleRequest";
    this.tableConfig.whereParams = "UserId eq " + this.user.id;
    this.tableConfig.actions.customTemplate = true;
    this.formatColumns();
  }

  get user() {
    return this.$store.state.user;
  }
  
  get refreshUserLoading() {
    return this.$store.state.refreshUserLoading;
  }
  
  mounted() {
    this.permissionAccess.view = true;
    this.permissionAccess.write = true;
    this.permissionAccess.managment = true;
    this.permissionAccess.permissionAccessLevel = true;
  }
  add() {
    this.$store.commit("setOpenAddRequesRoleModal", true);
  }
  view(id: number, data: RoleRequest, props: RowTable<RoleRequest>) {
    this.$router.push(`${this.$router.currentRoute.path}/view/${id}`);
  }
  formatColumns() {
    let userType = new BTableColumn(
      "userTypeDescription",
      "table.userType",
      true
    );

    let researchCenterDescription = new BTableColumn(
      "researchCenterDescription",
      "table.institutions",
      true
    );

    let roleRequestStatus = new BTableColumn(
      "roleRequestStatusDescription",
      "table.roleRequestStatus",
      true
    );
    researchCenterDescription.customTemplate = true;
    // researchType.customTemplate = true;
    this.tableConfig.insertColumns(
      userType,
      researchCenterDescription,
      roleRequestStatus
    );
  }

  @Watch("$store.state.updateRequestRoleTable")
  onOpenAddRequesRoleModal(value: boolean) {
    if (value) {
      this.tableConfig.reload();
      this.$store.commit("setUpdateRequestRoleTable", false);
    }
  }
}
